import React, { useEffect, useState, useRef, useMemo } from "react"; //eslint-disable-line
import { useMediaQuery } from "react-responsive";
import { format } from "date-fns";
import he from "he";
import { useTranslation } from "react-i18next";
import { MIX_PANEL_EVENTS } from "../../../utils/constans"; //eslint-disable-line
import { Remarkable } from "remarkable";
import { useMutation } from "react-query";
import { v4 as uuidv4 } from "uuid";
import { useMixPanel } from "../../../hooks/useMixPanel";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
/* Services */
import { fetchAssistantChatGPT } from "../../../services/chat.service";
import useCaseStore from "../../../store/useCaseStore";
import useGlobalStore from "../../../store/useGlobalStore";
import {
  getIteractionById,
  getSessionsByUseCase,
} from "../../../services/teacherSession.service";
import useSessionStore from "../../../store/useSessionStore";
/* Components */
import UseCaseHistory from "../../../components/UseCaseHistory/UseCaseHistory";
import Button from "../../../components/button/button"; //eslint-disable-line
import {
  cleanTableHTML,
  exportToDocx,
  htmlToMarkdown,
  htmlToPdf,
} from "../../../utils/Utils"; //eslint-disable-line

/* Assets */
import ShaiaCreate from "../../../assets/shaia_create.png";
import UserIcon from "../../../assets/icons/user_icon_blue.svg";
import ArrowBack from "../../../assets/icons/arrow_back.svg";
import HistoryEmpty from "../../../assets/icons/history_toggle_off.svg";
import Resources from "../../../assets/icons/resources.svg";
import EditNote from "../../../assets/icons/edit_note_yellow.svg";
import PictureAsPdf from "../../../assets/icons/picture_as_pdf.svg";
import DocIcon from "../../../assets/icons/doc-icon.svg";
import History from "../../../assets/icons/watch_later.svg";
import FirstPageIcon from "../../../assets/icons/first_page.svg";

/* Styles */
import "../../../components/chat/chat.css";
import classNames from "classnames";

import useTimer from "../../../hooks/useTimer";
import { getEnadActivities } from "../../../services/enad.service";
import ActivityItem from "./ActivityItem";
import ChatSkeleton from "../../../components/skeletons/ChatSkeleton";
import PdfViewer from "../../../components/PdfViewer/PdfViewer";
import Icon from "../../../components/icon/icon";

const DesignEnadActivity = ({ externalActivity = null, onBackToEnadTool }) => {
  const [showExtendedLoadingMessage, setShowExtendedLoadingMessage] =
    useState(false);
  const [history, setHistory] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [showTabs, setShowTabs] = useState(true);
  const [showBackToEnadToolButton, setShowBackToEnadToolButton] =
    useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [superPowerSession, setSuperPowerSession] = useState(null);
  const [disableMessages, setDisableMessages] = useState(false);
  const [knowledgeArea, setKnowledgeArea] = useState("");
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [isView, setIsView] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [step, setStep] = useState(1);
  const [messagesStep1, setMessagesStep1] = useState([]);
  const [messagesStep2, setMessagesStep2] = useState([]);
  const [messagesStep3, setMessagesStep3] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [resMessages, setResMessages] = useState([]);
  const [isEditorOn, setIsEditorOn] = useState(false);
  const [showActivityDetail, setShowActivityDetail] = useState(false);
  const [enadActivities, setEnadActivities] = useState([]);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const { setCreditAnimateClear } = useGlobalStore();
  const methods = useForm();
  const { handleSubmit, setValue } = methods;
  const navigate = useNavigate();
  const { sendEvent } = useMixPanel();
  const { useCaseList } = useCaseStore();
  const temporalLoadingRef = useRef(false);
  const parentSessionIdRef = useRef(null);
  const sessionIdRef = useRef(null);
  const chatContainerRef = useRef(null);
  const stepsRef = useRef(1);
  const [messages, setMessages] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 564 }); //eslint-disable-line
  const { t, i18n } = useTranslation(); //eslint-disable-line
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const level = queryParams.get("level");
  const { user } = useSessionStore();

  const { count, startTimer, resetTimer } = useTimer();

  const currentUseCase = useCaseList?.find(
    (e) => e.description === `cesa_sequence_setp_` //eslint-disable-line
  );
  const useCaseId = currentUseCase ? currentUseCase.id : null;
  const md = new Remarkable({
    html: true,
    breaks: true,
    typographer: true,
  });

  const resetFlow = () => {
    setResMessages([]);
    setMessages([]);
    setMessagesStep1([]);
    setMessagesStep2([]);
    setMessagesStep3([]);
    setStep(1);
    setDisableMessages(false);
    setIsEditorOn(false);
    setShowActivityDetail(false);
    setSelectedActivity(null);
    setSelectedAssetId(null);
    setSuperPowerSession(null);
    setKnowledgeArea("");
    setNewMessage("");
    setLoading(false);
    setIsView(null);
    setShowBackToEnadToolButton(false);
    setPdfFile(null);
  };

  useEffect(() => {
    if (count > 30) {
      scrollToBottom();
      setShowExtendedLoadingMessage(true);
    }
  }, [count]);

  const teacherSessionMutation = useMutation(getSessionsByUseCase, {
    onSuccess: (res) => {
      setHistory(res);
    },
    onError: () => {},
  });

  const getEnadActivitiesMutation = useMutation(getEnadActivities, {
    onSuccess: (res) => {
      const parseList = res.map((e) => ({
        ...e,
        value: e.id,
        label: e.name,
        show: true,
      }));
      setEnadActivities(parseList);
      setLoading(false);
    },
    onError: () => {},
  });

  useEffect(() => {
    scrollToBottom();
  }, [messages, step]);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const createMarkup = (nodeElement) => {
    if (nodeElement.includes("<div")) {
      return { __html: nodeElement };
    }
    const rawMarkup = md.render(nodeElement);
    return { __html: rawMarkup };
  };

  const conditions = [
    "<stage_1>",
    "<stage_2>",
    "<stage_3>",
    "contextoUsuario",
    "ContextoClase",
    "Enviar PDF_User",
  ];

  const getMessagesByStep = (currentStep) => {
    switch (currentStep) {
      case 1:
        return messagesStep1;
      case 2:
        return messagesStep2;
      case 3:
        return messagesStep3;
      default:
        return 1;
    }
  };

  useEffect(() => {
    if (!externalActivity && !onBackToEnadTool) {
      sessionByIdMutation.mutate(sessionId);
    }
    // eslint-disable-next-line
  }, [sessionId, externalActivity, onBackToEnadTool]);

  useEffect(() => {
    if (resMessages.length) {
      setMessagesByStep(resMessages);
      setNewMessage("");
      if (temporalLoadingRef.current) temporalLoadingRef.current = false;
      if (sessionIdRef.current) {
        sessionByIdMutation.mutate(sessionIdRef.current);
      }
      if (resMessages.length) {
        const cleanMessages = resMessages.map((e) => {
          return {
            ...e,
            content: transformContent(e?.content || e?.data?.content),
          };
        });
        setMessages(cleanMessages);
      }

      setLoading(false);
    }
  }, [resMessages]); //eslint-disable-line

  const getCurrentStepByUseCase = (slug) => {
    switch (slug) {
      case `cesa_clase_${level}_step_1`:
        return 1;
      case `cesa_clase_${level}_step_2`:
        return 2;
      case `cesa_clase_${level}_step_3`:
        return 2;
      default:
        return 1;
    }
  };

  const sessionByIdMutation = useMutation(getIteractionById, {
    onSuccess: (data) => {
      setDisableMessages(true);
      if (data?.data && data.data.session_id) {
        setSuperPowerSession(data.data);
        if (data.data?.classProfile) {
          setValue("courses", data.data?.classProfile);
        }
        if (data.data?.asset) {
          setSelectedAssetId(data.data.asset.id);
        }
        const currentStepMessages = [];
        const currentStep = getCurrentStepByUseCase(data.data.superPower.slug);
        stepsRef.current = currentStep;
        const historyStep1Messages = data?.data?.messages;
        currentStepMessages.push({
          step: currentStep,
          messages: historyStep1Messages,
        });

        parentSessionIdRef.current = data?.data?.parent_session_id || null;
        if (data.history.length) {
          data.history.forEach((element) => {
            const historyStepMessages = element.messages;
            currentStepMessages.push({
              step: getCurrentStepByUseCase(element.superPower.slug),
              messages: historyStepMessages,
            });
          });
        }
        const satinizedMessages = [];
        currentStepMessages
          .sort((a, b) => a.step - b.step)
          .forEach((e) => {
            satinizedMessages.push(...e.messages);
            setMessagesByInitialStep(e.step, e.messages);
          });
        const cleanMessages = satinizedMessages.map((e) => {
          return {
            ...e,
            content: transformContent(e.content || e.data.connect),
          };
        });
        setMessages(cleanMessages);
        const historyStep2Messages = data.data.messages;

        const findStage2 = historyStep2Messages.find(
          (e) =>
            (e?.role === "assistant" ||
              e?.type === "assistant" ||
              e?.type === "ai" ||
              e?.role === "ai") &&
            (e?.content?.includes("<stage_2>") ||
              e?.data?.content?.includes("<stage_2>"))
        );
        if (findStage2) {
          const historyStep1 = data?.history.find(
            (e) => e.superPower.slug === `cesa_clase_${level}_step_1`
          );
          const historyStep1Messages = historyStep1.messages;
          const cleanMessages = [
            ...historyStep1Messages,
            ...historyStep2Messages,
          ].map((e) => {
            return {
              ...e,
              content: transformContent(e.content || e.data.connect),
            };
          });
          setMessages(cleanMessages);
          setStep(5);
          setIsEditorOn(true);
        }
      } else {
        parentSessionIdRef.current = data?.data?.parent_session_id || null;
      }
      setStep(5);
    },
    onError: (error) => {},
  });

  const mutation = useMutation(fetchAssistantChatGPT, {
    onSuccess: (res) => {
      setDisableMessages(true);
      temporalLoadingRef.current = false;
      resetTimer();
      setShowExtendedLoadingMessage(false);
      setLoading(false);
      setResMessages(res?.messages);
      scrollToBottom();
    },
    onError: () => {
      resetTimer();
      setShowExtendedLoadingMessage(false);
      setLoading(false);
    },
  });

  const setMessagesByStep = (currentMessages) => {
    switch (stepsRef.current) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;
      case 3:
        setMessagesStep3(currentMessages);
        break;
      default:
        return 1;
    }
  };

  const setMessagesByInitialStep = (initialStep, currentMessages) => {
    switch (initialStep) {
      case 1:
        setMessagesStep1(currentMessages);
        break;
      case 2:
        setMessagesStep2(currentMessages);
        break;
      case 3:
        setMessagesStep3(currentMessages);
        break;
      default:
        return 1;
    }
  };

  const send = (message, temporalEnadActivity = null) => {
    const currentEnadActivity = temporalEnadActivity || selectedActivity;
    startTimer();
    if (message && message.trim() !== "") {
      const payload = {
        role: "user",
        content: message === "N/A" ? "" : message,
      };
      getMessagesByStep(stepsRef.current); // analizar funcion para borrar o mantener
      setMessages([...messages, { ...payload }]);
      setNewMessage("");

      if (!sessionId) {
        sessionIdRef.current = uuidv4();
        navigate(
          `/design-enad-${externalActivity ? "class" : "activity"}?sessionId=${
            sessionIdRef.current
          }`
        );
      }
      temporalLoadingRef.current = true;
      setDisableMessages(true);
      mutation.mutate({
        messages: [payload], //eslint-disable-line
        type: "enad_activity",
        session_id: sessionId || sessionIdRef.current,
        parent_session_id: parentSessionIdRef.current || null,
        use_case_id: useCaseId,
        lang: i18n.language,
        class_profile_id: null,
        asset_ids: selectedAssetId ? [selectedAssetId] : [],
        response_type: null,
        response_schema: null,
        enad_activity_id: currentEnadActivity?.id || null,
      });
    }
  };

  const sendMessage = () => {
    if (newMessage && newMessage.trim() !== "") {
      send(newMessage);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (e.shiftKey || e.ctrlKey) {
        // Permite el salto de línea con Shift+Enter o Ctrl+Enter
        return;
      } else {
        // Evita el comportamiento predeterminado de "Enter" en un textarea (añadir una nueva línea)
        e.preventDefault();
        sendMessage();
      }
    }
  };

  const handleGobackToEnadClassTool = () => {
    if (onBackToEnadTool) {
      const editableDiv = document.getElementById("editable-div");

      if (editableDiv) {
        // Captura el contenido actualizado del div editable
        const currentContent = htmlToMarkdown(editableDiv.innerHTML);
        onBackToEnadTool(currentContent, selectedActivity.name);
        resetFlow();
      }
    }
  };

  useEffect(() => {
    teacherSessionMutation.mutate(`enad_activity`);
    setLoading(true);
    getEnadActivitiesMutation.mutate();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      superPowerSession &&
      superPowerSession?.enad_activity_id &&
      enadActivities.length
    ) {
      setShowActivityDetail(true);
      const findCurrentEnadActivity = enadActivities.find(
        (e) => e.id === superPowerSession.enad_activity_id
      );
      if (!pdfFile) {
        setPdfFile(findCurrentEnadActivity?.asset?.asset_uri);
        setActiveTab(2)
      }
      if (pdfFile && pdfFile !== findCurrentEnadActivity?.asset?.asset_uri) {
        setPdfFile(findCurrentEnadActivity?.asset?.asset_uri);
        setActiveTab(2)
      }
    }
  }, [superPowerSession, enadActivities, pdfFile]);

  const trackBackEvent = () => {
    if (isMobile) {
      navigate("/");
    }
    setCreditAnimateClear();
    sendEvent(MIX_PANEL_EVENTS.classBackHome);
  };

  useEffect(() => {
    const addCollapsibleBehavior = () => {
      const tables = document.querySelectorAll(".chat-message-content table");

      tables.forEach((table) => {
        const thead = table.querySelector("thead");
        const tbody = table.querySelector("tbody");

        if (thead && tbody) {
          // Crear el contenedor de la tabla
          const wrapper = document.createElement("div");
          wrapper.classList.add("table-wrapper");

          // Insertar el contenedor antes de la tabla
          table.parentNode.insertBefore(wrapper, table);

          // Mover la tabla dentro del contenedor
          wrapper.appendChild(table);

          thead.classList.add("close");

          thead.addEventListener("click", () => {
            if (tbody.style.display === "none") {
              tbody.style.display = "table-row-group";
              thead.classList.remove("close");
              thead.classList.add("open");
            } else {
              tbody.style.display = "none";
              thead.classList.remove("open");
              thead.classList.add("close");
            }
          });
        }
      });
    };

    addCollapsibleBehavior();
  }, [messages]);

  useEffect(() => {
    if (externalActivity && enadActivities.length) {
      const cleanedActivity = externalActivity.name.replace(/\*\*/g, "").trim();
      const findCurrentActivity = enadActivities.find(
        (e) => e.name.trim() === cleanedActivity
      );
      if (findCurrentActivity) {
        setKnowledgeArea(findCurrentActivity.knowledge_area);
        onStartIteraction(findCurrentActivity);
      }
    }
    // eslint-disable-next-line
  }, [externalActivity, enadActivities]);

  // const cleanBeforePDFContent = (content) => {
  //   // Define una expresión regular para eliminar el contenido no deseado basado en el atributo id
  //   const regex = /<div id="edit-section" class="flex justify-center gap-2">[\s\S]*?<\/div>\s*<\/div>|<div id="save-cancel-section" class="flex justify-center gap-2 hidden">[\s\S]*?<\/div>/g;
  //   return content.replace(regex, '');
  // };

  // const cleanBeforePDFContent = (content) => {
  //   // Define una expresión regular para capturar el contenido dentro del div con id="bubble-editable-container"
  //   const match = content.match(
  //     /<div id="bubble-editable-container"[\s\S]*?<\/div>/
  //   );
  //   return match ? match[0] : "";
  // };
  const onDownloadLibraryPDF = async () => {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage) {
      const editableDiv = document.getElementById("editable-div");

      if (editableDiv) {
        // Captura el contenido actualizado del div editable
        lastMessage.content = editableDiv.innerHTML;
      }
      const md = new Remarkable({
        html: true,
        breaks: true,
        typographer: true,
      });
      // const cleanedContent = cleanBeforePDFContent(lastMessage.content);
      let html = md.render(lastMessage.content);
      html = he.decode(html);
      html = cleanTableHTML(html);
      await htmlToPdf(
        "Explicar actividad ENAd",
        `${user?.first_name || ""} ${user?.last_name || ""}`.trim(),
        "Explicar actividad ENAd",
        html,
        true
      );
    }
  };

  // const extractEditableDivContent = (content) => {
  //   // Define una expresión regular para capturar el contenido dentro del div con id="editable-div"
  //   const match = content.match(
  //     /<div id="editable-div"[\s\S]*?>([\s\S]*?)<\/div>/
  //   );
  //   return match ? match[1] : "";
  // };

  const onExportToWord = async () => {
    const lastMessage = messages[messages.length - 1];
    if (lastMessage) {
      const md = new Remarkable({
        html: true,
        breaks: true,
        typographer: true,
      });
      const editableDiv = document.getElementById("editable-div");

      if (editableDiv) {
        // Captura el contenido actualizado del div editable
        lastMessage.content = editableDiv.innerHTML;
      }
      // const cleanedContent = extractEditableDivContent(lastMessage.content);

      let html = md.render(lastMessage.content);
      html = he.decode(html);
      html = cleanTableHTML(html);
      await exportToDocx(html, "Explicar actividad ENAd");
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const editButtonContainer = document.getElementById(
        "edit-button-container"
      );
      const wordButtonContainer = document.getElementById(
        "word-button-container"
      );
      const pdfButtonContainer = document.getElementById(
        "pdf-button-container"
      );
      const cancelButton = document.getElementById("cancel-button");
      const saveButton = document.getElementById("save-button");
      const editableDiv = document.getElementById("editable-div");
      const bubbleContainer = document.getElementById(
        "bubble-editable-container"
      );
      const editSection = document.getElementById("edit-section");
      const saveCancelSection = document.getElementById("save-cancel-section");

      const toggleEditable = () => {
        if (
          editableDiv &&
          bubbleContainer &&
          editSection &&
          saveCancelSection
        ) {
          const isEditable =
            editableDiv.getAttribute("contentEditable") === "true";
          editableDiv.setAttribute("contentEditable", !isEditable);
          if (!isEditable) {
            bubbleContainer.classList.add("bg-DarkBlue-500");
            editSection.classList.add("hidden");
            saveCancelSection.classList.remove("hidden");
          } else {
            bubbleContainer.classList.remove("bg-DarkBlue-500");
            editSection.classList.remove("hidden");
            saveCancelSection.classList.add("hidden");
          }
        }
      };

      const setEditableFalse = () => {
        if (
          editableDiv &&
          bubbleContainer &&
          editSection &&
          saveCancelSection
        ) {
          editableDiv.setAttribute("contentEditable", "false");
          bubbleContainer.classList.remove("bg-DarkBlue-500");
          editSection.classList.remove("hidden");
          saveCancelSection.classList.add("hidden");
        }
      };

      if (editButtonContainer) {
        editButtonContainer.addEventListener("click", toggleEditable);
      }

      if (wordButtonContainer) {
        wordButtonContainer.addEventListener("click", onExportToWord);
      }

      if (pdfButtonContainer) {
        pdfButtonContainer.addEventListener("click", onDownloadLibraryPDF);
      }

      if (cancelButton) {
        cancelButton.addEventListener("click", setEditableFalse);
      }

      if (saveButton) {
        saveButton.addEventListener("click", () => {
          // Aquí puedes agregar la lógica para guardar los cambios
          setEditableFalse();
        });
      }

      return () => {
        if (editButtonContainer) {
          editButtonContainer.removeEventListener("click", toggleEditable);
        }
        if (pdfButtonContainer) {
          pdfButtonContainer.removeEventListener("click", onDownloadLibraryPDF);
        }
        if (wordButtonContainer) {
          wordButtonContainer.removeEventListener("click", onExportToWord);
        }
        if (cancelButton) {
          cancelButton.removeEventListener("click", setEditableFalse);
        }
        if (saveButton) {
          saveButton.removeEventListener("click", setEditableFalse);
        }
      };
    }, 0); // Delay of 0 milliseconds to allow the DOM to update

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [messages]);

  const getPreOrPosGrade = (data) => {
    if (data?.superPower?.slug === "cesa_clase_pregrado_step_2")
      return "pregrado";
    if (data?.superPower?.slug === "cesa_clase_posgrado_step_2")
      return "posgrado";
  };

  const quickReplies = [
    t("enad_actividad_respuesta_rapida_no_preguntas"),
    t("enad_actividad_respuesta_rapida_finalizar_explicacion"),
  ];

  const handleQuickReply = (message) => {
    send(message);
  };

  const toggleView = (buttonName, data) => {
    navigate(
      `/design-enad-activity?level=${getPreOrPosGrade(data)}&sessionId=${
        data.session_id
      }`
    );
    setIsView(buttonName);
  };
  const filteredMessages = messages
    ?.filter(
      (e) =>
        !conditions.some(
          (stage) =>
            e?.content?.includes(stage) || e?.data?.content.includes(stage)
        )
    )
    .filter((e) => e?.content || e?.data?.content);

  const onSelectEnadAvivity = (item) => {
    setSelectedActivity(item);
  };

  const transformContent = (content) => {
    let transformedContent = content;
    const hasElements = /<elements>[\s\S]*?<\/elements>/.test(content);
    const hasActivityId = /<id_actividad>[\s\S]*?<id_actividad>/.test(content);
    const hasActivityProcess =
      /<Activity_Process>[\s\S]*?<\/Activity_Process>/.test(content);
    if (hasElements) {
      transformedContent = transformedContent.replace(
        /<elements>[\s\S]*?<\/elements>/g,
        ""
      );
    }
    if (hasActivityId) {
      transformedContent = transformedContent.replace(
        /<id_actividad>[\s\S]*?<id_actividad>/g,
        ""
      );
    }
    if (hasActivityProcess) {
      const processMatch = transformedContent.match(
        /<Activity_Process>([\s\S]*?)<\/Activity_Process>/
      );
      if (processMatch) {
        if (externalActivity) {
          setShowBackToEnadToolButton(true);
        }
        const processContent = processMatch[1];

        const editableContent = `
          <div id="bubble-editable-container" class="flex flex-col justify-center p-4" >
            <div id="editable-div" class="editable-content rounded-lg p-4 outline-none">
              ${md.render(processContent)}
              </div>
            <div id="edit-section" class="flex justify-evenly gap-2">
              <div id="edit-button-container" class="cursor-pointer text-Yellow-500" >
                <img class="h-10 w-10" src="${EditNote}" alt="resources" />
                <button id="edit-button" ="edit-button">Edit</button>
              </div>

              <div id="word-button-container" class="cursor-pointer text-Yellow-500" >
                <img class="h-10 w-10" src="${DocIcon}" alt="word" />
                <button ='word'>Word</button>
              </div>

              <div id="pdf-button-container" class="cursor-pointer text-Yellow-500" >
                <img class="h-10 w-10" src="${PictureAsPdf}" alt="pdf" />
                <button ='pdf'>PDF</button>
              </div>     
            </div>
            <div id="save-cancel-section" class="flex justify-center gap-2 hidden">
                <button id="cancel-button" class="edit-button bg-Yellow-500 text-DarkBlue-500 rounded-md p-2 w-full">
                
                Cancelar</button>
                <button id="save-button" class="edit-button bg-shaiaBlue text-DarkBlue-500 rounded-md p-2 w-full">Guardar</button>
            </div>
          </div>
          
        `;
        transformedContent = transformedContent.replace(
          /<Activity_Process>[\s\S]*?<\/Activity_Process>/g,
          editableContent
        );
      }
    }

    return transformedContent;
  };

  const onStartIteraction = (item) => {
    const keyWords = ["Ninguno.", "No aplica."];
    const userInput = `
        Enviar PDF_User input: No
        Nombre de docente: ${user?.first_name || ""} ${user?.last_name || ""} 

        Área de enseñanza: ${knowledgeArea || ""}
        Categoría:${item?.category || ""}

        Info. de actividad seleccionada:
        (
        ${
          !keyWords.includes(item.name) && item?.name
            ? `* Nombre de la actividad: ${item?.name}`
            : ""
        }
        ${
          !keyWords.includes(item.levels) && item?.levels
            ? `* Niveles: ${item?.levels}`
            : ""
        }
        ${
          !keyWords.includes(item.activity_competencies) &&
          item?.activity_competencies
            ? `* Competencias de la actividad: ${item?.activity_competencies}`
            : ""
        }
        ${
          !keyWords.includes(item.purpose) && item?.purpose
            ? `* Propósto: ${item?.purpose}`
            : ""
        }
        ${
          !keyWords.includes(item.materials) && item?.materials
            ? `* Materiales: ${item?.materials}`
            : ""
        }
        ${
          !keyWords.includes(item.all_classroom_phase_1) &&
          item?.all_classroom_phase_1
            ? `* Proceso Fase 1_Para todo el salón: ${item?.all_classroom_phase_1}`
            : ""
        }
        ${
          !keyWords.includes(
            item.process_phase_1_1_for_the_whole_room_and_small_groups
          ) && item?.process_phase_1_1_for_the_whole_room_and_small_groups
            ? `* Proceso Fase 1.1_Para todo el salón y grupos pequeños: ${item?.process_phase_1_1_for_the_whole_room_and_small_groups}`
            : ""
        }
        ${
          !keyWords.includes(item.process_phase_2_for_small_groups) &&
          item?.process_phase_2_for_small_groups
            ? `* Proceso Fase 2_Para grupos pequeños: ${item?.process_phase_2_for_small_groups}`
            : ""
        }
        ${
          !keyWords.includes(item.process_phase_3_individual_practice) &&
          item?.process_phase_3_individual_practice
            ? `* Proceso Fase 3_Práctica individual: ${item?.process_phase_3_individual_practice}`
            : ""
        }
        ${
          !keyWords.includes(
            item.process_phase_4_for_small_groups_and_individual_practice
          ) && item?.process_phase_4_for_small_groups_and_individual_practice
            ? `* Proceso Fase 4_Para grupos pequeños y práctica individual: ${item?.process_phase_4_for_small_groups_and_individual_practice}`
            : ""
        }
        ${
          !keyWords.includes(item.tips) && item?.tips
            ? `* Tips: ${item?.tips}`
            : ""
        }
        ${
          !keyWords.includes(item.variations) && item?.variations
            ? `* Variaciones: ${item?.variations}`
            : ""
        }
        ${
          !keyWords.includes(
            item.competencies_according_to_variations_and_levels
          ) && item?.competencies_according_to_variations_and_levels
            ? `* Competencias según variaciones y niveles: ${item?.competencies_according_to_variations_and_levels}`
            : ""
        }
        )
    `;
    setShowActivityDetail(true);
    setSelectedActivity(item);
    send(userInput, item);
  };

  const handleSelectKnowlwsdgeArea = (knowledgeArea) => {
    setKnowledgeArea(knowledgeArea);
  };

  const handlShowTabs = () => {
    setShowTabs(!showTabs);
  };

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const onSubmit = () => {};

  const onReload = () => {
    navigate("/design-enad-activity");
    resetFlow();
  };

  if (loading) {
    return <ChatSkeleton />;
  }
  return (
    <>
      {!isMobile && !externalActivity && (
        <div className="back-button">
          <Link to={"/"} className="back-button_arrow" onClick={trackBackEvent}>
            <img src={ArrowBack} className="" alt="" />
            {t("inicio")}
          </Link>
          <span className="back_button_root">
            {t("enad_actividad_encabezado_entender")} /
          </span>
          <span className="back_button_page">
            {t("enad_actividad_encabezado_titulo")}
          </span>
        </div>
      )}
      <div className="wrapper editor !justify-around !gap-4 !w-full">
        {/* Historial */}

        <div
          className={classNames(
            "sidebar_history !h-auto max-h-desktopWrapper !max-w-none !pl-0 !pt-0 w-[30%]",
            {
              "w-[10%] !bg-transparent": !showTabs,
              "w-[30%]": showTabs && activeTab === 1,
              active: isActive,
            }
          )}
        >
          <div className=" w-full tabs flex justify-between text-shaiaBlue !pr-0">
            {showTabs && (
              <>
                {!externalActivity && (
                  <div
                    className={classNames(
                      "tab w-full gap-2 p-2 text-sm rounded-r-3 flex justify-center cursor-pointer ",
                      {
                        "bg-[#222d4f]": activeTab !== 1,
                      }
                    )}
                    onClick={() => setActiveTab(1)}
                  >
                    <div className="flex items-center">
                      <img src={HistoryEmpty} alt="empty" />
                    </div>
                    <div className="flex items-center">
                      {t("historialTitulo")}
                    </div>
                  </div>
                )}

                {pdfFile && (
                  <div
                    className={classNames(
                      "tab w-full gap-2 p-2 text-sm rounded-l-3 rounded-r-3 flex justify-center items-center cursor-pointer ",
                      {
                        "bg-[#222d4f]": activeTab !== 2,
                      }
                    )}
                    onClick={() => setActiveTab(2)}
                  >
                    <div className="flex items-center">
                      <img src={Resources} alt="empty" />
                    </div>
                    <div className="flex items-center">{t("enad_actividad_pdf_actividad")}</div>
                  </div>
                )}
              </>
            )}
            <div
              className={classNames(
                "tab w-full p-2 text-sm bg-DarkBlue-900 flex items-center justify-center cursor-pointer",
                { "rounded-3xl": !showTabs },
                { "rounded-l-3 ": showTabs }
              )}
              onClick={() => handlShowTabs()}
            >
              <div className="flex items-center">
                <img src={FirstPageIcon} alt="empty" />
              </div>
              <div className="flex items-center">
                {t(showTabs ?"enad_actividad_ocultar": "enad_actividad_mostrar")}
              </div>
            </div>
          </div>
          <div className="tab-content w-full pl-6">
            {!externalActivity && showTabs && activeTab === 1 && (
              <>
                {history.length ? (
                  <UseCaseHistory
                    history={history}
                    sessionId={null}
                    isView={isView}
                    toggleView={toggleView} //eslint-disable-line
                  />
                ) : (
                  <>
                    <div className="history_empty">
                      <img src={HistoryEmpty} alt="empty" />
                      <p className="blue-text">{t("historialTituloVacio")}</p>
                    </div>
                  </>
                )}
              </>
            )}
            {pdfFile && showTabs && activeTab === 2 && (
              <PdfViewer file={pdfFile} />
            )}
            {activeTab === 3 && <div>{/* Contenido del Tab 3 */}</div>}
          </div>
        </div>

        {/* Chat */}
        <div
          className={classNames("h-full  flex flex-col justify-end md:gap-4 ", {
            "w-[60%]": !isMobile && showTabs,
            "w-[70%]": !isMobile && showTabs && activeTab === 1,
            "w-[90%]": !isMobile && !showTabs,
            "w-full": isMobile,
          })}
        >
          <div
            ref={chatContainerRef}
            className={`flex flex-col flex-grow justify-end h-0 overflow-y-auto relative sm-max:px-0 sm-max:pt-0 sm-max:pb-4 sm-max:bg-transparent ${
              isEditorOn && "px-1 pt-1 pb-3 "
            }`}
          >
            <div className="chat_wrapper-scroll pr-2">
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)} className="h-auto">
                  {!externalActivity && (
                    <div
                      className={classNames(
                        "chat_conversation-thread-ai ml-2",
                        {
                          "pointer-events-none": disableMessages,
                          "opacity-50": disableMessages,
                        }
                      )}
                    >
                      <div className="bubble-wrapper">
                        <div className="chat_bubble_2-ai bg-Grey-950 bg-opacity-35 border-transparent">
                          <div className="flex items-center justify-start gap-2 mb-4">
                            <div className="chat_avatar-ai_2 items-start ">
                              <img
                                className="chat_avatar-ai-img"
                                src={ShaiaCreate}
                                alt="Sha.ia"
                              />
                            </div>
                            <div className="text-[#3D96C2] text-sm">Shaia</div>
                          </div>

                          <div className="bubble-message flex flex-col gap-2">
                            <div>¡Hola!</div>
                            <div>
                              Para empezar, elige el área de enseñanza. Una vez
                              seleccionada, te mostraré las actividades
                              asociadas para que elijas la que deseas explorar.
                            </div>
                            <div className="flex p-2 gap-2 mt-2">
                              <button
                                type="button"
                                className={classNames(
                                  "w-full rounded-md border-2 p-2 text-sm font-bold",
                                  {
                                    "border-shaiaBlue bg-shaiaBlue text-DarkBlue-500":
                                      knowledgeArea === "Lectura",
                                    "text-white border-white bg-transparent":
                                      knowledgeArea === "Matemáticas",
                                  }
                                )}
                                onClick={() =>
                                  handleSelectKnowlwsdgeArea("Lectura")
                                }
                              >
                                Lectura
                              </button>
                              <button
                                type="button"
                                className={classNames(
                                  "w-full rounded-md border-2 p-2 text-sm font-bold",
                                  {
                                    "border-shaiaBlue bg-shaiaBlue text-DarkBlue-500":
                                      knowledgeArea === "Matemáticas",
                                    "text-white border-white bg-transparent ":
                                      knowledgeArea === "Lectura",
                                  }
                                )}
                                onClick={() =>
                                  handleSelectKnowlwsdgeArea("Matemáticas")
                                }
                              >
                                Matemáticas
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!externalActivity && knowledgeArea && (
                    <div
                      className={classNames(
                        "chat_conversation-thread-ai ml-2",
                        {
                          "pointer-events-none": disableMessages,
                          "opacity-50": disableMessages,
                        }
                      )}
                    >
                      <div className="bubble-wrapper">
                        <div className="chat_bubble_2-ai bg-Grey-950 bg-opacity-35 border-transparent">
                          <div className="flex items-center justify-start gap-2 mb-4">
                            <div className="chat_avatar-ai_2 items-start">
                              <img
                                className="chat_avatar-ai-img"
                                src={ShaiaCreate}
                                alt="Sha.ia"
                              />
                            </div>
                            <div className="text-[#3D96C2]">Shaia</div>
                          </div>
                          <div className="bubble-message flex flex-col gap-2">
                            <div>
                              Perfecto, vamos a explorar las actividades del
                              área de enseñanza de {knowledgeArea}:
                            </div>
                            <div className="flex flex-col gap-2 h-60 overflow-y-auto p-2">
                              {enadActivities
                                .filter((e) =>
                                  knowledgeArea
                                    ? e.knowledge_area === knowledgeArea
                                    : e
                                )
                                .map((activity, i) => (
                                  <ActivityItem
                                    key={i}
                                    onSelect={onSelectEnadAvivity}
                                    displayDetail={
                                      activity?.id === selectedActivity?.id &&
                                      !showActivityDetail
                                    }
                                    item={activity}
                                    onStartIteraction={onStartIteraction}
                                  />
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedActivity && showActivityDetail && (
                    <div
                      className={classNames(
                        "chat_conversation-thread-ai ml-2",
                        {
                          "pointer-events-none": disableMessages,
                          "opacity-50": disableMessages,
                        }
                      )}
                    >
                      <div className="bubble-wrapper">
                        <div className="chat_bubble_2-ai bg-Grey-950 bg-opacity-35 border-transparent">
                          <div className="flex items-center justify-start gap-2 mb-4">
                            <div className="chat_avatar-ai_2 items-start">
                              <img
                                className="chat_avatar-ai-img"
                                src={ShaiaCreate}
                                alt="Sha.ia"
                              />
                            </div>
                            <div className="text-[#3D96C2]">Shaia</div>
                          </div>
                          <div className="bubble-message">
                            <div>
                              Perfecto, vamos a explorar las actividades del
                              área de enseñanza de {knowledgeArea}:
                            </div>
                            <div className="flex flex-col gap-2 p-2">
                              <ActivityItem
                                displayDetail
                                item={selectedActivity}
                                selected
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </FormProvider>
              {/* Chat dinámico con la respuesta AI */}
              {filteredMessages?.map((message, i) => {
                const formattedTime = message?.createdAt
                  ? format(new Date(message?.createdAt), "hh:mm a")
                  : "";
                const isAi =
                  message?.role === "assistant" ||
                  message?.type === "ai" ||
                  message?.role === "ai";
                const isUser =
                  message?.role === "user" ||
                  message?.type === "human" ||
                  message?.role === "human";
                return (
                  <div
                    key={i}
                    className={`max-w-full chat_conversation-thread-${
                      isUser ? "user" : "ai ml-2"
                    }
                    }`}
                  >
                    <div className={classNames("bubble-wrapper")}>
                      <div
                        className={`chat_bubble_2-${isUser ? "user" : "ai"} `}
                      >
                        <div
                          className={classNames("flex items-center ", {
                            "gap-0 mb-1 flex-row-reverse": isUser,
                            "justify-start gap-2 mb-4": isAi,
                          })}
                        >
                          <div
                            className={`chat_avatar-${
                              isUser ? "user_2 p-1" : "ai_2 items-start"
                            }`}
                          >
                            {isUser && (
                              <img className="" src={UserIcon} alt="Tú" />
                            )}
                            {isAi && (
                              <img
                                className="chat_avatar-ai-img "
                                src={ShaiaCreate}
                                alt="Sha.ia"
                              />
                            )}
                          </div>
                          <div className="text-[#3D96C2] text-sm flex items-center ">
                            {isUser
                              ? `${user?.first_name || ""} ${
                                  user?.last_name || ""
                                }`
                              : "Shaia"}
                          </div>
                          <div
                            className={classNames("text-white text-xs", {
                              "mr-2": isUser,
                            })}
                          >
                            {formattedTime}
                          </div>
                        </div>
                        <div
                          className={`bubble-message ${
                            isEditorOn ? "xl:px-2" : "xl:px-10"
                          }`}
                        >
                          {["user", "assistant", "ai", "human"].includes(
                            message?.role || message?.type
                          ) && (
                            <div
                              className="chat-message-content"
                              dangerouslySetInnerHTML={createMarkup(
                                message?.content || message?.data?.content
                              )}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              {(loading || temporalLoadingRef.current) && (
                <div className="chat_conversation-thread-ai ml-2">
                  <div className="bubble-wrapper">
                    <div className="chat_bubble_2-ai">
                      <div className="flex items-center justify-start gap-2 mb-4">
                        <div className="chat_avatar-ai_2 items-start">
                          <img
                            className="chat_avatar-ai-img"
                            src={ShaiaCreate}
                            alt="Sha.ia"
                          />
                        </div>
                        <div className="text-[#3D96C2]">Shaia</div>
                      </div>
                      <p className="bubble-message chat-typing">
                        {t("chat_mensaje_escribiendo")}
                        {!showExtendedLoadingMessage && (
                          <>
                            <span>.</span> <span>.</span> <span>.</span>
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {(loading || temporalLoadingRef.current) &&
                showExtendedLoadingMessage && (
                  <div className="chat_conversation-thread-ai ml-2">
                    <div className="bubble-wrapper">
                      <div className="chat_bubble_2-ai w-full">
                        <div className="flex items-center justify-start gap-2 mb-4">
                          <div className="chat_avatar-ai_2 items-start">
                            <img
                              className="chat_avatar-ai-img"
                              src={ShaiaCreate}
                              alt="Sha.ia"
                            />
                          </div>
                          <div className="text-[#3D96C2]">Shaia</div>
                        </div>
                        <p className="bubble-message chat-typing">
                          {t("chat_mensaje_espera")}
                          <span>.</span> <span>.</span> <span>.</span>
                        </p>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
          {showBackToEnadToolButton ? (
            <div className="w-full flex justify-center">
              <div className="w-full md:w-[30%] lg:w-[30%]">
                <button
                  onClick={() => handleGobackToEnadClassTool()}
                  type="button"
                  className=" bg-Yellow-500 text-DarkBlue-500 rounded-md p-2 w-full font-bold"
                >
                  Continuar planeación
                </button>
              </div>{" "}
            </div>
          ) : null}
          {/* Input message */}
          {step >= 5 && !isEditorOn && (
            <div className="flex flex-col gap-4 sm-max:gap-2 w-full">
              <div
                className={`w-full min-h-16 max-h-25 bg-DarkBlue-700/90 rounded-4 sm-max:rounded-4 py-2 px-4 flex flex-row gap-2 flex-grow`}
              >
                <textarea
                  className="max-h-20 bg-white/13 text-Grey-500 font-semibold rounded-1 shadow flex-col justify-center items-center inline-flex placeholder:text-Grey-800 w-full p-2 text-4"
                  placeholder={`${t("abp_chat_placeholder")} ...`}
                  value={newMessage}
                  disabled={loading}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <Button
                  label={
                    loading || temporalLoadingRef.current ? (
                      <svg
                        aria-hidden="true"
                        className="w-6 h-6 text-Grey-200 animate-spin dark:text-Grey-600 fill-DarkBlue-300"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    ) : (
                      t("abp_boton_enviar")
                    )
                  }
                  variant="primary"
                  disabled={loading}
                  onClick={sendMessage}
                  customClassName="w-30"
                />
              </div>
            </div>
          )}
          {filteredMessages.length ? (
            <div className="w-full overflow-x-auto sm-max:mt-2 ">
              <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-2 items-center justify-end ">
                {!onBackToEnadTool && (
                  <div className="w-full flex justify-center md:justify-start">
                    <button
                      onClick={() => onReload()}
                      type="button"
                      className="bg-Yellow-500 text-DarkBlue-500 p-2 rounded-md font-bold text-sm "
                    >
                      {t("enad_actividad_explicame_otra_actividad")}
                    </button>
                  </div>
                )}
                <div className="w-full flex items-center justify-end gap-4">
                  <p className="h-full text-sm  sm-max:flex-1 sm-max:min-w-20 flex items-center justify-end text-LightBlue-500 font-bold m-0">
                    {t("enad_actividad_respuestas_rapidas")}:
                  </p>
                  {quickReplies.map((reply, index) => (
                    <button
                      key={index}
                      className="text-sm  sm-max:flex-1  py-2 px-3 rounded-full border border-solid border-LightBlue-500 bg-LightBlue-500/50 text-3.5 leading-3.5 text-Grey-500"
                      disabled={loading}
                      onClick={() => handleQuickReply(reply)}
                    >
                      {reply}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {isMobile && (
        <div className="fixed z-sticky bottom-0 left-0 w-screen h-16 bg-DarkBlue-700 px-4 flex flex-row gap-4 items-center justify-between rounded-tl-4 rounded-tr-4">
          <Icon
            icon={ArrowBack}
            iconText={t("regresar")}
            customClassName="gap-1 py-0 w-19"
            onClick={trackBackEvent}
            disabledToolTip={true}
          />

          <>
            <Icon
              icon={History}
              iconText={"Historial"}
              customClassName="gap-1 w-19"
              onClick={toggleClass}
              disabledToolTip={true}
            />
            {/* <Icon
                icon={History}
                iconText={"Más acciones"}
                customClassName="gap-1 w-19"
                onClick={toggleOtherActions}
                disabledToolTip={true}
              /> */}
          </>
        </div>
      )}
    </>
  );
};

export default DesignEnadActivity;
